import type { ModelSelection, ProviderKind as ProviderKindType } from "@cmmd-forge/contracts";
import { ProviderKind } from "@cmmd-forge/contracts";

interface ProviderIdentitySource {
  readonly provider: string | null | undefined;
  readonly model: string | null | undefined;
  readonly providerAccountId: string | null | undefined;
}

function knownProvider(value: string | null | undefined): ProviderKindType | null {
  return ProviderKind.literals.find((provider) => provider === value) ?? null;
}

function modelSelection(source: ProviderIdentitySource | null): ModelSelection | null {
  const provider = knownProvider(source?.provider);
  const model = source?.model;
  if (!provider || !model) return null;
  if (provider === "codex" || provider === "claudeAgent") {
    return {
      provider,
      model,
      ...(source?.providerAccountId ? { providerAccountId: source.providerAccountId } : {}),
    };
  }
  return { provider, model };
}

export function resolveRemoteThreadProviderIdentity(input: {
  readonly replica: ProviderIdentitySource | null;
  readonly inventory: ProviderIdentitySource | null;
  readonly hasUserMessage: boolean;
}): {
  readonly selection: ModelSelection | null;
  readonly lockedProvider: ProviderKindType | null;
} {
  const selection = modelSelection(input.replica) ?? modelSelection(input.inventory);
  return {
    selection,
    lockedProvider: input.hasUserMessage ? (selection?.provider ?? null) : null,
  };
}
